module.exports = __webpack_public_path__ + "9dbaca5b55635e113e9de8c470afb4fa.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/orks-vignette-preview-460.webp.png
// module id = 497
// module chunks = 0